import { render, staticRenderFns } from "./ViewCollection.vue?vue&type=template&id=ca3c491e"
import script from "./ViewCollection.vue?vue&type=script&lang=js"
export * from "./ViewCollection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports